<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>

  </div>
  @if (formGroup) {
    <form [formGroup]="formGroup"
      (ngSubmit)="save()">
      @if (step() === 1) {
        <div class="icon">
          <ion-icon name="business-outline"></ion-icon>
        </div>
        <h1>{{ 'subcontractor.titlePartner' | translate }}</h1>
        <ion-label>{{ 'signup.businessName' | translate }}</ion-label>
        <ion-item color="secondary">
          <ion-input autocapitalize="on"
            formControlName="name"></ion-input>
        </ion-item>
        <ion-label>{{ 'signup.businessId' | translate }}</ion-label>
        <ion-item color="secondary">
          <ion-input autocapitalize="on"
            formControlName="businessId"></ion-input>
        </ion-item>
        <ion-button color="light"
          shape="round"
          (click)="step.set(2)">
          {{ 'general.next' | translate }}
        </ion-button>
      } @else if (step() === 2) {
        <h1>{{ 'subcontractor.inviteTitle' | translate }}</h1>
        <p>{{ 'subcontractor.inviteInfoPartner' | translate }}</p>
        <h4>{{ 'contractor.adminAccounts' | translate }}</h4>
        <form formArrayName="admins">
          @for (item of getFields('admins').controls; track item; let i = $index) {
            <div [formGroupName]="i"
              class="flex tw:flex">
              <div>
                <ion-label>{{ 'partnerNote.username' | translate }}</ion-label>
                <ion-item color="secondary">
                  <ion-input autocapitalize="on"
                    formControlName="displayName"></ion-input>
                </ion-item>
              </div>
              <div>
                <ion-label>{{ 'partnerNote.userEmail' | translate }}</ion-label>
                <ion-item color="secondary">
                  <ion-input formControlName="email"
                    type="email"></ion-input>
                </ion-item>
              </div>
            </div>
          }
        </form>
        <h4>{{ 'contractor.supervisorAccounts' | translate }}</h4>
        <form formArrayName="supervisors">
          @for (item of getFields('supervisors').controls; track item; let i = $index) {
            <div [formGroupName]="i"
              class="flex tw:flex">
              <div>
                <ion-label>{{ 'partnerNote.username' | translate }}</ion-label>
                <ion-item color="secondary">
                  <ion-input autocapitalize="on"
                    formControlName="displayName"></ion-input>
                </ion-item>
              </div>
              <div>
                <ion-label>{{ 'partnerNote.userEmail' | translate }}</ion-label>
                <ion-item color="secondary">
                  <ion-input formControlName="email"
                    type="email"></ion-input>
                </ion-item>
              </div>
            </div>
          }
        </form>
        <h4>{{ 'contractor.workersAccounts' | translate }}</h4>
        <form formArrayName="workers">
          @for (item of getFields('workers').controls; track item; let i = $index) {
            <div [formGroupName]="i"
              class="flex tw:flex">
              <div>
                <ion-label>{{ 'partnerNote.username' | translate }}</ion-label>
                <ion-item color="secondary">
                  <ion-input autocapitalize="on"
                    formControlName="displayName"></ion-input>
                </ion-item>
              </div>
              <div>
                <ion-label>{{ 'partnerNote.userEmail' | translate }}</ion-label>
                <ion-item color="secondary">
                  <ion-input formControlName="email"
                    type="email"></ion-input>
                </ion-item>
              </div>
            </div>
          }
        </form>
        <div class="ion-margin-top">
          <ion-button color="light"
            shape="round"
            type="submit"
            [disabled]="!formGroup.valid">{{ 'subcontractor.sendInvite' | translate }}</ion-button>
        </div>
      } @else if (step() === 3) {
        <h1>{{ 'contractor.summary' | translate }}</h1>
        <p>{{ 'partnerNote.invited' | translate }}</p>
        <div class="ion-margin-top">
          <ion-button color="light"
            shape="round"
            (click)="dismiss()">{{ 'general.done' | translate }}</ion-button>
        </div>
      }
    </form>
  }
</app-main-dialog>